




































import { StudentService } from '../../biz/remote/StudentService';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { TableColumn } from '../../components/organisms/CommonTable.vue';
import { dayjs, DT_FORMAT, D_FORMAT_JA, getSchoolAge, getSchoolAgeNameObject, T_FORMAT, T_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { StudentInfoInputDTO } from '../../../src_server/entity/dto/StudentInfoInputDTO';
import { ActorType, ActorTypeNames } from '../../../src_server/biz/ActorType';
import StudnetInfoMaintenance from '../students_list/StudnetInfoMaintenance.vue';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { routeHelper } from '../../utils/routeHelper';
import { buildingData } from '../../../src_server/entity/master/buildingData';
import { Session } from '../../utils/Session';
import { AuthService } from '../../biz/remote/AuthService';
import { MessageDialog } from '../../utils/MessageDialog';
import SimpleSelect from '../../components/inputs/SimpleSelect.vue';
import DaLessonDialog from './DaLessonDialog.vue';
import DaSelectCourseDialog from './DaSelectCourseDialog.vue';
import { SupportPlan } from '../../../src_server/entity/generated/SupportPlan';

@Component({ components: { StudnetInfoMaintenance, SimpleSelect, DaLessonDialog, DaSelectCourseDialog } })
export default class DaStudentsListPage extends Vue {
  public viewCount = 10;
  public cols: TableColumn[] = (() => {
    const cols: TableColumn[] = [];
    cols.push({ label: 'No', type: 'seq' });

    cols.push({
      label: '申込時間',
      type: 'renderfunc',
      width: '100px',
      sortitem: 'student.insert_dt',
      representedAs: (row: any) => {
        if (!row.student || !row.student.insert_dt) return '';
        return `${dayjs(row.student.insert_dt).format(DT_FORMAT)}`;
      },
    });
    cols.push({
      label: '年齢',
      type: 'renderfunc',
      sortitem: 'student.birth_day',
      representedAs: (row: any) => {
        if (!row.student || !row.student.birth_day) return '';
        return `${dayjs().diff(dayjs(row.student.birth_day), 'y')}`;
      },
    });
    cols.push({
      label: '学年',
      type: 'renderfunc',
      sortitem: 'student.birth_day',
      representedAs: (row: any) => {
        if (!row.student || !row.student.birth_day) return '';
        const schoolAge = getSchoolAge(row.student.birth_day);
        return `${getSchoolAgeNameObject(schoolAge).shortName}`;
      },
    });

    cols.push({ label: '氏名', name: 'student.full_name', width: '100px' });
    cols.push({ label: '学校名', name: 'student.school_name' });
    cols.push({
      label: '写真掲載可',
      type: 'renderfunc',
      representedAs: (row: any) => {
        if (!row.student || !row.student.can_up_photo) return '';
        return `<i class="fas fa-check" v-if="st.is_done"></i>`;
      },
      sortitem: 'student.can_up_photo',
    });
    cols.push({ label: 'ログインメール', name: 'userAuth.email' });
    cols.push({
      label: 'モニタリング',
      name: 'da_monitoring_state',
      sortitem: 'da_monitoring_state',
    });

    cols.push({
      label: 'メッセージ履歴',
      btnClass: { btn: true, 'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-905rem small-xs': true },
      onclick: this.messageLog,
    });

    cols.push({
      label: 'パスワード<br>リセット',
      btnClass: { btn: true, 'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-905rem small-xs': true },
      onclick: this.passwordReset,
    });

    cols.push({
      label: '個別支援計画',
      btnClass: { btn: true, 'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-905rem small-xs': true },
      onclick: this.supportPlan,
    });

    cols.push({
      label: 'コース選択',
      btnClass: { btn: true, 'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-905rem small-xs': true },
      onclick: this.courseSelect,
    });

    cols.push({
      label: '日報閲覧',
      btnClass: { btn: true, 'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r  w-705rem  small-xs': true },
      onclick: this.showReport,
    });
    cols.push({
      label: '詳細',
      btnClass: { btn: true, 'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-505rem  small-xs': true },
      onclick: this.detail,
    });
    return cols;
  })();

  private loading = false;
  private rows: StudentInfoInputDTO[] = [];
  private originalRows: StudentInfoInputDTO[] = [];

  get buildings() {
    return buildingData;
  }

  async created() {
    await this.loadData();
  }

  @Watch('filter')
  async loadData() {
    this.loading = true;
    const biz = new StudentService();
    const response = await biz.getAll_da(Session.getSessionBuildingId());
    this.originalRows = response.data;
    this.rows = this.originalRows
      .filter((r) => {
        this.loading = false;
        if (!this.filter) return true;
        return r.student.full_name?.match(this.filter);
      })
      .map((d) => {
        if (d.support_plan) {
          d.da_monitoring_state = this.monitoringLimit(d.support_plan);
        }
        return d;
      });
    this.loading = false;
  }

  private filter = '';

  getCommunicateName(actorType: string) {
    const actorTypeObj = ActorType.getInstanceByName(actorType as ActorTypeNames);
    if (!actorTypeObj) return '';
    return `${actorTypeObj.typeName}`;
  }

  monitoringLimit(sp: SupportPlan): string {
    // 開始も終了もない
    if (!sp.start_dt || !sp.end_dt) {
      return '未作成';
    }

    // 有効期限切れ
    if (dayjs(sp.end_dt).diff(dayjs()) < 0) {
      return '有効期限 切れ';
    }

    // モニタリングが一度も作られていない
    if (!sp.monitoring_create_dt) {
      // 'モニタリング未作成';
      // 本日から期限までの日数を計算
      const leftDate = dayjs(sp.end_dt).diff(dayjs(), 'day');
      if (leftDate < 30) {
        return '30日以内';
      } else {
        return 'OK';
      }
    }
    // モニタリングが作られている
    // 有効期限-モニタリング作成日
    if (dayjs(sp.start_dt).diff(dayjs(sp.monitoring_create_dt), 'day') < 0) {
      // モニタリングの作成日が期限より前
      // 本日から期限までの日数を計算
      const leftDate = dayjs(sp.end_dt).diff(dayjs(), 'day');
      if (leftDate < 30) {
        return '30日以内';
      } else {
        return 'OK';
      }
    } else {
      // モニタリングが期限内に作られている = OK
      return 'モニタリング作成済';
    }
  }

  /**
   * 詳細ボタンのイベントハンドラ
   */
  detail(row: any) {
    const dialog = this.$refs['student_detail_dialog'] as StudnetInfoMaintenance;
    dialog.show(row);
  }

  cancel() {
    const dialog = this.$refs['student_detail_dialog'] as CommonDialog;
    dialog.hide();
  }

  deleteStudent(user_id: string) {
    this.rows.splice(
      this.rows.findIndex((p) => p.userAuth.user_id === user_id),
      1
    );
  }

  supportPlan(row: any) {
    const user_id = row.userAuth.user_id;
    routeHelper(this, 'DaSupportPlanPage', { user_id: user_id });
  }

  /**
   * コース選択のダイアログを表示
   */
  async courseSelect(row: StudentInfoInputDTO) {
    const dialog = this.$refs['da_select_course_dialog'] as DaSelectCourseDialog;
    await dialog.show(row.student.user_id!);
  }

  showReport(row: any) {
    const user_id = row.userAuth.user_id;
    (this.$refs['da_lesson_dialog'] as DaLessonDialog).show(user_id, row.userAuth.user_name, Session.getSessionBuildingId());
  }

  async passwordReset(row: any) {
    const isOK = await MessageDialog.confirm(`パスワードをリセットして生徒へ通知します。よろしいですか？`);
    if (isOK) {
      const user_id = row.userAuth.user_id;
      const authBiz = new AuthService();
      const response = await authBiz.resetInitPassword(user_id, Session.getSessionBuildingId());
      await MessageDialog.alert(response.data);
    }
  }

  async messageLog(row: any) {
    routeHelper(this, 'AdminMessagePage', { user_id: row.userAuth.user_id, user_type: 'stu' });
  }
}
